<template>
    <div class="px-4 py-4 sm:px-6 text-right border-t border-gray-200">
        <slot></slot>
    </div>
</template>